import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title, 
  description, 
  keywords,
  author = "Dr. Lim Siow Jin",
  type = "website",
  image = "https://www.dxn2u.com/founder/images/Datuk-Lim.jpg",
  url
}) => {
  const siteTitle = title ? `${title} | Dr. Lim Siow Jin` : "Dr. Lim Siow Jin - Visionary Entrepreneur | Zen Master | Wellness Pioneer";
  const siteDescription = description || "Dr. Lim Siow Jin (Dhyanacharya Nagajiva) - Founder of DXN Holdings, Sunya meditation teacher, and wellness pioneer. Integrating business excellence, natural wellness, and spiritual wisdom for global transformation.";
  const baseUrl = typeof window !== 'undefined' ? window.location.origin : "https://drlimnagajiva.com";
  const currentPath = typeof window !== 'undefined' ? window.location.pathname : "/";
  const siteUrl = url || `${baseUrl}${currentPath}`;
  
  const schemaOrg = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Person",
        "@id": `${siteUrl}/#person`,
        "name": "Dr. Lim Siow Jin",
        "alternateName": ["Dhyanacharya Nagajiva", "Datuk Dr. Lim Siow Jin"],
        "description": siteDescription,
        "image": image,
        "url": siteUrl,
        "jobTitle": ["Founder & Executive Chairman", "Zen Master", "Wellness Pioneer"],
        "worksFor": {
          "@type": "Organization",
          "name": "DXN Holdings Bhd"
        },
        "affiliation": [
          {
            "@type": "Organization",
            "name": "Sunyatee International Foundation"
          },
          {
            "@type": "Organization",
            "name": "DXN Holdings Bhd"
          }
        ],
        "award": [
          "Panglima Jasa Negara (PJN)",
          "Dato' Setia Diraja Kedah",
          "Mother Teresa International Award",
          "Albert Schweitzer Award"
        ],
        "knowsAbout": [
          "Traditional Chinese Medicine",
          "Sunya Meditation",
          "Ganotherapy",
          "Network Marketing",
          "Wellness",
          "Shang Han Lun"
        ],
        "sameAs": [
          "https://instagram.com/limsiowjin",
          "https://youtube.com/@sunyastudios",
          "https://www.dxn2u.com/founder"
        ]
      },
      {
        "@type": "Organization",
        "@id": `${siteUrl}/#organization`,
        "name": "DXN Holdings Bhd",
        "url": "https://www.dxn2u.com",
        "founder": {
          "@id": `${siteUrl}/#person`
        },
        "foundingDate": "1993",
        "description": "Global wellness company with presence in 180+ countries, 15-20 million distributors, and RM1.6B revenue",
        "areaServed": "Worldwide"
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "Dr. Lim Siow Jin Official Website",
        "description": siteDescription,
        "publisher": {
          "@id": `${siteUrl}/#person`
        },
        "inLanguage": ["en", "es", "zh", "ms", "hi"]
      }
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={siteDescription} />
      <meta name="keywords" content={keywords || "Dr. Lim Siow Jin, Sunya meditation, DXN, Ganoderma, wellness, Traditional Chinese Medicine, Shang Han Lun, meditation, spirituality, network marketing"} />
      <meta name="author" content={author} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Dr. Lim Siow Jin" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={siteDescription} />
      <meta property="twitter:image" content={image} />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>
    </Helmet>
  );
};

export default SEOHead;
